import rootPath from './rootPath';

export default rootPath;
